export const EMPTY_UUID = "00000000-0000-0000-0000-000000000000";

export const browserSafeUuid = () =>
  "10000000-1000-4000-8000-100000000000".replace(/[018]/g, c => (+c ^ (randomValue() & (15 >> (+c / 4)))).toString(16));

const randomValue = () => crypto.getRandomValues(new Uint8Array(1))[0] as number;
